export default __webpack_public_path__ + "static/media/img-service-import.4d459fe7.svg";